import styled from "styled-components";

const MyProfileSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;
  .myprofile-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2em;
  }
  .personal-details {
    padding: 1em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .personal-details-main {
    background-color: #ece3e3db;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 10px;
    padding: 2em;
    margin-right: 2em;
  }

  .my-own-details {
    align-self: center;
  }
  .profile-image {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 1em;
  }

  .profile-details {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .profile-name {
    font-size: 1.2em;
    font-weight: bold;
    margin: 0;
  }

  .profile-role-region {
    margin: 0;
    color: #6c757d;
    align-self: center;
  }

  .form-label {
    margin: 0;
    font-weight: bold;
    color: #6c757d;
  }

  .apply-button {
    align-self: flex-end;
  }

  .cards-main {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2em;
    padding: 2rem;
  }

  .cards-profile {
    width: 70vw;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    padding: 2em;
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  .table-edit-content {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0px 1em;
  }

  .th-prof-tab {
    font-weight: bold;
    font-size: 1.2em;
    color: #333;
    width: 30%;
  }

  .td-prof-tab {
    font-size: 1.2em;
    color: #666;
  }

  .edit-button {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .edit-button button {
    background-color: #3f51b5;
    color: #fff;
    border-radius: 10px;
    padding: 1em 2em;
    font-size: 1em;
    border: none;
    cursor: pointer;
  }

  .edit-button button:hover {
    background-color: #2c3e50;
  }

  @media screen and (max-width: 768px) {
    .myprofile-content {
      flex-direction: column;
      padding: 1em;
    }

    .personal-details-main,
    .profile-details {
      flex-direction: column;
      gap: 5px;
    }

    .profile-name {
      font-size: 1.5em;
      margin-top: 0.5em;
    }

    .profile-image {
      width: 75px;
      height: 75px;
      margin-right: 0;
      margin-bottom: 0.5em;
    }
  }
`;

export default MyProfileSc;
